import { render, staticRenderFns } from "./showdatatorviews.vue?vue&type=template&id=5a6e7f0b"
import script from "./showdatatorviews.vue?vue&type=script&lang=js"
export * from "./showdatatorviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports